// Helpers de @menciones SIN dependencias de React: viven aparte de RichEditor.tsx
// para que ese archivo exporte SOLO componentes y React Fast Refresh (HMR) funcione
// limpio. Mezclar un export no-componente (esta función) en el módulo del editor
// invalidaba el Fast Refresh y forzaba recargas en cascada del árbol.

// Emails mencionados dentro de un doc tiptap (nodos 'mention', id = email).
// PostEditor la usa antes de POST/PATCH para poblar {mentions} y disparar el fan-out.
export function extractMentions(json: string): string[] {
  const out = new Set<string>()
  const walk = (node: unknown): void => {
    if (node == null || typeof node !== 'object') return
    if (Array.isArray(node)) return void node.forEach(walk)
    const n = node as { type?: string; attrs?: { id?: unknown }; content?: unknown }
    if (n.type === 'mention' && typeof n.attrs?.id === 'string') out.add(n.attrs.id.toLowerCase())
    if (n.content !== undefined) walk(n.content)
  }
  try {
    walk(JSON.parse(json))
  } catch {
    /* doc inválido → sin menciones */
  }
  return [...out]
}

// Candidato del autocompletar de @menciones (la misma forma que MentionMember de
// RichEditor, repetida aquí para que este módulo siga sin depender del editor).
export interface Mencionable {
  email: string
  name: string
  photoUrl?: string | null
  /**
   * Es del equipo pero NO del proyecto. Se ofrece igual —mencionarlo es la forma
   * natural de darse cuenta de que falta— pero marcado, porque la mención no le
   * llega: el API filtra a los no-miembros antes del fan-out (notificaciones.md).
   */
  fueraDelProyecto?: boolean
}

/** Tope de filas del desplegable: más de seis ya no se lee de un vistazo. */
export const TOPE_SUGERENCIAS_MENCION = 6

/**
 * Lo que ofrece el desplegable para lo tecleado después de la @. La lista llega ya
 * ordenada con los miembros PRIMERO: con todo el equipo en el roster, sin ese orden
 * un "@an" llenaba las seis filas con gente de fuera y escondía a la Ana del proyecto.
 */
export function filtrarMencionables<T extends Mencionable>(lista: T[], consulta: string): T[] {
  const q = consulta.toLowerCase()
  return lista
    .filter((m) => m.name.toLowerCase().includes(q) || m.email.toLowerCase().includes(q))
    .slice(0, TOPE_SUGERENCIAS_MENCION)
}

/** Inicial para el avatarcito cuando no hay foto (pill y desplegable). */
export function initialOf(label: string): string {
  const clean = label.replace(/^@/, '').trim()
  return (clean[0] ?? '?').toUpperCase()
}
